'use strict';

function isHTTPS() {
  return global.location.protocol === 'https:';
}

module.exports = {
  isHTTPS: isHTTPS
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/lib/is-https.js
// module id = 774
// module chunks = 0